import { mapExpensesToFormRows } from '#/modules/momMgmt/workOrder/helper/workOrderExpenses';

/**
 * detail → 表單；顯示欄（mtrNo／bom*）不送 API。
 */
export function mapWorkOrderDetailToFormValues(detail) {
  const quantity = detail?.quantity ?? {};
  const mtr = detail?.mtr ?? {};
  const bom = detail?.bom ?? {};

  return {
    scheduledStartDate: detail?.scheduledStartDate ?? '',
    issueReason: detail?.issueReason ?? '',
    remark: detail?.remark ?? '',
    mtrId: mtr.id ?? detail?.mtrId ?? '',
    mtrNo: mtr.mtrNo ?? '',
    mtrName: mtr.name ?? '',
    bomId: bom.id ?? '',
    bomCode: bom.code ?? '',
    bomName: bom.name ?? '',
    bomVersion: bom.version ?? '',
    bomStatus: bom.status ?? 'ACTIVE',
    processingFactoryId: detail?.processingFactory?.id
      ?? detail?.processingFactoryId
      ?? '',
    workWarehouseId: detail?.workWarehouse?.id ?? detail?.workWarehouseId ?? '',
    targetWarehouseId: detail?.targetWarehouse?.id
      ?? detail?.targetWarehouseId
      ?? '',
    manufacturingQty: quantity.manufacturingQty ?? '',
    bomMaterialSelections: mapBomMaterialSelectionsFromDetail(
      detail?.bomMtrSelections ?? detail?.bomMaterialSelections,
    ),
    expenses: mapExpensesToFormRows(detail?.expenses),
  };
}

export function mapCandidateToFormPatch(candidate) {
  const mtr = candidate?.mtr ?? {};
  const bom = candidate?.bom ?? {};

  return {
    mtrId: mtr.id ?? '',
    mtrNo: mtr.mtrNo ?? '',
    mtrName: mtr.name ?? '',
    bomId: bom.id ?? '',
    bomCode: bom.code ?? '',
    bomName: bom.name ?? '',
    bomVersion: bom.version ?? '',
    bomStatus: bom.status ?? '',
    bomMaterialSelections: [],
  };
}

function mapBomMaterialSelectionsFromDetail(rows = []) {
  return (rows ?? []).map((row) => {
    const groupMtr = row?.sourceGroupMtr ?? row?.sourceGroupMaterial;
    const selectedMtr = row?.selectedMtr;
    return {
      sourceGroupMaterialId: groupMtr?.id
        ?? row?.sourceGroupMaterialId
        ?? row?.sourceGroupMtrId
        ?? '',
      selectedMaterialId: selectedMtr?.id
        ?? row?.selectedMaterialId
        ?? row?.selectedMtrId
        ?? '',
      sourceGroupMtrNo: groupMtr?.mtrNo
        ?? row?.sourceGroupMtrNo
        ?? '',
      sourceGroupMtrName: groupMtr?.name
        ?? row?.sourceGroupMtrName
        ?? '',
    };
  });
}
